// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!./rootVars.module.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    height: 100%;
    overflow: hidden;
  }

h1, h2, h3, h4, h5, h6, p {
    margin: 0;
    padding: 0;
  }

kbd {
    text-transform: capitalize;
  }

body {
    font-size: 14px !important;
    background: var(--colors-greyExtraLight);
  }

table {
    border-collapse: collapse;
    border-spacing: 0;
  }

strong, b {
    font-weight: bold;
  }

a {
    color: inherit;
    text-decoration: inherit;
  }

#react-refresh-overlay {
    display: none;
  }

#render-app {
    position: relative;
    /* z-index: 1; */
    height: 100%;
  }

#render-app > div[data-reactroot] {
    height: 100%;
    flex-flow: row wrap;
    display: flex;
    flex-direction: column;
  }

#render-context-menu {
    z-index: 2;
  }

.page {
    position: relative;
    height: 100%;
  }

select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 var(--colors-black);
  }

*::-moz-focus-inner {
    border: none;
  }

/**
    * HotKeys React module add a border on focus element
    */

div:focus, span:focus {
    outline: none;
  }

.componentBloc {
    background: #fff;
    padding: 20px;
  }

::-webkit-scrollbar-track {
  background-color: none;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.2);
}

* {
  scrollbar-width: thin;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-styles-___main-module__widget {
  padding: 10px;
  box-sizing: border-box;
  border: var(--mainBorder);
  background-color: #fff;
}

input[type='text']::-moz-placeholder {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input[type='text']::placeholder {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./app/styles/main.module.scss"],"names":[],"mappings":"AAGE;IAEE,YAAY;IACZ,gBAAgB;EAClB;;AAEA;IAOE,SAAS;IACT,UAAU;EACZ;;AAEA;IACE,0BAA0B;EAC5B;;AAEA;IACE,0BAA0B;IAC1B,wCAAwC;EAC1C;;AAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;AAEA;IAEE,iBAAiB;EACnB;;AAEA;IACE,cAAc;IACd,wBAAwB;EAC1B;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,kBAAkB;IAElB,gBAAgB;IAChB,YAAY;EACd;;AAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;AAEA;IACE,UAAU;EACZ;;AAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;AAEA;IACE,kBAAkB;IAClB,sCAAsC;EACxC;;AAEA;IACE,YAAY;EACd;;AAEA;;KAEG;;AACH;IAEE,aAAa;EACf;;AAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;AAGF;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAJA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["@import url(rootVars.module.scss);\n\n:global {\n  html,\n  body {\n    height: 100%;\n    overflow: hidden;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    margin: 0;\n    padding: 0;\n  }\n\n  kbd {\n    text-transform: capitalize;\n  }\n\n  body {\n    font-size: 14px !important;\n    background: var(--colors-greyExtraLight);\n  }\n\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n\n  strong,\n  b {\n    font-weight: bold;\n  }\n\n  a {\n    color: inherit;\n    text-decoration: inherit;\n  }\n  // disable webpack overlay\n  #react-refresh-overlay {\n    display: none;\n  }\n\n  #render-app {\n    position: relative;\n    // empêche le z-index des notifications d'être pris en compte => retiré pour que les notifs apparaissent par dessus les modals\n    /* z-index: 1; */\n    height: 100%;\n  }\n\n  #render-app > div[data-reactroot] {\n    height: 100%;\n    flex-flow: row wrap;\n    display: flex;\n    flex-direction: column;\n  }\n\n  #render-context-menu {\n    z-index: 2;\n  }\n\n  .page {\n    position: relative;\n    height: 100%;\n  }\n\n  select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 var(--colors-black);\n  }\n\n  *::-moz-focus-inner {\n    border: none;\n  }\n\n  /**\n    * HotKeys React module add a border on focus element\n    */\n  div:focus,\n  span:focus {\n    outline: none;\n  }\n\n  .componentBloc {\n    background: #fff;\n    padding: 20px;\n  }\n}\n\n::-webkit-scrollbar-track {\n  background-color: none;\n}\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 5px;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n* {\n  scrollbar-width: thin;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.widget {\n  padding: 10px;\n  box-sizing: border-box;\n  border: var(--mainBorder);\n  background-color: #fff;\n}\n\ninput[type='text']::placeholder {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"widget": `app-styles-___main-module__widget`
};
export default ___CSS_LOADER_EXPORT___;
